import React from "react";
import "./ExpenseCard.css";
import deletePngIcon from "../../images/delete.png";
import { useDispatch } from "react-redux";
import { rxDB } from "../../redux";
// import moment from "moment";

const ExpenseCard = ({ expense, deleteNotify, delKey }) => {
  // const momentsTime = moment(expense.createdAt).fromNow();

  const dispatch = useDispatch();

  const deleteExpensehandler = () => {
    dispatch(rxDB.deleteExpense(delKey.uid));

    deleteNotify();
  };

  return (
    <div
      key={expense.id}
      style={{
        borderRight: `12px solid ${expense.categoryColor}`,
        padding: `.25rem 1rem`,
        backgroundColor: `${expense.categoryColor}40`,
      }}
      className="expenseCard"
    >
      <div className="expense__titleLeft">
        <div className="expenseLeft1">{expense.title}</div>
        <div className="expense__DateAdded">
          {expense.createdAt.slice(1, -4)}
        </div>
      </div>
      <div className="expense__rightBar">
        <img
          onClick={deleteExpensehandler}
          src={deletePngIcon}
          alt="delete"
          className="delete__PngExpense"
        />
        <div className="expense__Amount__RightBar">₹ {expense.amount}</div>
      </div>
    </div>
  );
};

export default ExpenseCard;
